import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SocialDialog from '../Dialog/component';
import { resetSelectedClipsPreview } from '../../../../../state/selectedClipsPreview';
import {
  enableClipperKeyboardControls,
  disableClipperKeyboardControls,
} from '../../../../VirtualClipper/state/videoPlayer';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onDialogEntered: () => dispatch(disableClipperKeyboardControls()),
  onDialogExited: () => {
    dispatch(enableClipperKeyboardControls());
    dispatch(resetSelectedClipsPreview());
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(SocialDialog);
